import { render, staticRenderFns } from "./InicioView.vue?vue&type=template&id=eb1b6a42&"
import script from "./InicioView.vue?vue&type=script&lang=js&"
export * from "./InicioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports